import { api } from './'

export const ticketsExist = () => api.get('tickets/exist').json<{ exists: boolean }>()
